import { useState, useEffect } from 'react';
import Markdown from 'react-markdown'
import './Costelgpt.css'
import { Skeleton } from '@mui/material';
import { UserAuth } from '../../context/AuthContext';
import strings from "../../locales/ro.json"
import config from "../../config"
import costelGptService from '../../services/costelgpt';

function CostelgptMessage({text, sender}) {


  const isUser = sender === 'user'
  return <div style={{display: 'flex',marginTop:'1rem', justifyContent: isUser?'flex-end':'flex-start', fontSize:'1.25rem', textJustify:'inter-word'}}>
    <div className={isUser?'costelgpt-speechbubble-user':''} style={{maxWidth: "100%",overflowWrap: 'break-word'}}>
    {sender !== 'user' && <img src="/icons/costelgpt.svg"></img>}
    <Markdown>{text}</Markdown>
  </div>
  </div>
}

function CostelgptToneButton({toneIconPath, toneName, selectedToneName, onClickFcn}) {
  return <button onClick={onClickFcn} type="button" style={{display:'flex',justifyContent:'flex-start',gap:'8px',padding:'0px 8px', width:'100%', fontSize: '1.25rem', borderColor:'transparent', backgroundColor:toneName === selectedToneName ? 'var(--light-gray)' : 'inherit'}}>
    <img style={{width:'16px'}} src={toneIconPath} alt={toneName}></img> {toneName}
  </button>
}

export default function Costelgpt() {
  const [inputValue, setInputValue] = useState("");
  const [messages, setMessages] = useState([]);
  const [speakingTone, setSpeakingTone] = useState('Normal')
  const [isToneDialogOpen, setIsToneDialogOpen] = useState(false)
  const [isThinking, setIsThinking] = useState(false)
  const [isInfoDialogOpen, setIsInfoDialogOpen] = useState(false)
  const [width, setWidth] = useState(window.innerWidth);

  const { user } = UserAuth()

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
      
      //dynamically resize!
      window.addEventListener("resize", handleWindowSizeChange);
      return () => {
        window.removeEventListener("resize", handleWindowSizeChange);
      };
    }, []);
    const isMobile = width <= 768;

  const handleToneButtonClick = () => {
    setIsToneDialogOpen((prevValue) => {
      return !prevValue
    })
  }

  const handleInfoButtonClick = () => {
    setIsInfoDialogOpen((prevValue) => {
      return !prevValue
    })
  }

  const handleCostelgptSubmit = async (e) => {
    e.preventDefault();
    setMessages((_) => {
          const newArr = [{text: inputValue, sender: "user"}];
          return newArr;
        })
    setIsThinking(true)
    setInputValue("");
    try {
        const result = await costelGptService.prompt(inputValue,speakingTone,user.accessToken)
        setMessages((prevArr) => {
          const newArr = [...prevArr, {text: result, sender: "costelgpt"}];
          return newArr
        })
    } catch (e) {
        console.log(e)
        setMessages((prevArr) => {
          return [...prevArr, {text: 'Oops! Ceva s-a stricat! Daca problema persista, anunta-l pe adrian.manole@eestec.ro!', sender: 'costelgpt'}];
        });
    }
    setIsThinking(false);
    
  };

  return (
    <div style={{ padding: '20px', maxWidth: '100%'}}>
      {isInfoDialogOpen && <div style={{
        position:'absolute',
        left:'50%',
        top:isMobile?'50%':'40%',
        transform:'translateX(-50%) translateY(-50%)',
        backgroundColor:'#FFFFFF',
        padding:isMobile?'8px 16px':'32px 86px',
        zIndex:'100',
        fontSize:'1rem',
        borderRadius:'16px',
        width:isMobile?"90%":"inherit",
        boxShadow:'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px'
      }}>
        <div style={{display:'flex', justifyContent:'center'}}>
          <img src='./icons/costelgpt-info-corporate.svg' alt='Informatii'></img>
        </div>
        {strings.costelgpt.info.map((paragraph) => {
          return <p>{paragraph}</p>
        })}
        <div style={{display:'flex',justifyContent:'center'}}>
          <button onClick={handleInfoButtonClick} style={{backgroundColor:'var(--eestec-red)',border:'none', padding:'14px 24px', borderRadius:'12px', color:'#ffffff', fontSize:'1rem'}}>
            Am Inteles
          </button>
        </div>
      </div>}
      <div style={{width:'100%',position:'absolute', left:'50%',top:'15%', transform: 'translateX(-50%)', maxHeight:'65vh', overflowY:'scroll', display:'flex', justifyContent:'center'}}>

        <div style={{width:isMobile ? '90%' : '33%' }}>
        {messages.length === 0 && <div style={{fontFamily:'Lato'}}>
            <h2 style={{display:'flex', alignItems:'center', gap:'8px'}}><img src='/icons/costelgpt.svg' style={{width:'24px'}}></img> Buna!</h2>
            <h3>Eu sunt CostelGPT. Imi poti pune orice intrebare despre EESTEC, iar eu voi incerca sa raspund cat de bine pot!</h3>
        </div>}
        {
          messages.map((message) => {
            return <CostelgptMessage text={message.text} sender={message.sender}/>
          })
        }
        {isThinking && <div style={{marginTop:'1rem', fontSize:'1.25rem'}}><img src="/icons/costelgpt.svg"></img><Skeleton/><Skeleton/><Skeleton/><Skeleton/><Skeleton/></div>}
      </div>
    </div>
    <form 
      onSubmit={handleCostelgptSubmit} 
      style={{display:'flex', position: 'absolute', bottom: '24px', width: isMobile?'90%':'33%', left: '50%', transform:'translateX(-50%)', fontSize:'1rem' }}
    >
      <textarea 
        disabled={isThinking}
        type="text"
        placeholder="Intreaba-l pe CostelGPT..."
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (!isThinking && inputValue.trim()) {
              handleCostelgptSubmit(e);
            }
          }
        }}
        style={{ 
          flex: 1, 
          padding: '8px', 
          borderRadius: '4px',
          borderStyle:'solid',
          borderWidth:'1px',
          borderColor:'var(--eestec-red)',
          boxShadow:'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px', 
          border: '1px solid #ccc',
          minHeight: '9rem',
          height: 'fit-content',
          resize: 'none',
          fontSize: '1.25rem'
        }}
      />
      {inputValue && <button 
        type="submit" 
        style={{ 
          backgroundColor: 'rgba(0,0,0,0)', 
          color: 'white', 
          border: 'none', 
          borderRadius: '4px',
          cursor: 'pointer',
          position: 'absolute',
          right: '8px',
          bottom: '8px',
          opacity: isMobile?'100%':'50%',
        }}
        className='costelgpt-submit-button'
      >
        <img src="./icons/costelgpt-send.svg" alt='send'></img>
      </button>}
      <button 
        type='button'
        onClick={handleToneButtonClick}
        style={{
          position: 'absolute',
          left: '8px',
          bottom: '8px',
          borderColor: 'transparent',
          backgroundColor: 'inherit',
          width: '24px'
        }}
      >
        <img src='./icons/speaking-tone.svg'></img>
      </button>
      {isToneDialogOpen && <div style={{
        position: 'absolute',
        fontFamily:'Roboto',
        display:'flex',
        flexDirection:'column',
        justifyContent:'flex-start',
        alignItems:'flex-start',
        bottom:'40px',
        left:'16px',
        backgroundColor:'var(--white)',
        borderWidth:'1px',
        borderColor:'var(--light-gray)',
        borderStyle:'solid',
        borderRadius:'16px',
        overflow:'hidden',
        boxShadow:'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        padding: '16px 0px'
      }}>
          {strings.costelgpt.tones.map((tone) => {
            return <CostelgptToneButton toneName={tone.name} toneIconPath={tone.iconPath} selectedToneName={speakingTone} onClickFcn={() => {setSpeakingTone(tone.name); setIsToneDialogOpen(false);}}/>
          })}
        </div>}
      <button type='button' onClick={handleInfoButtonClick} style={{
        borderColor:'transparent',
        backgroundColor:'inherit',
        position:'absolute',
        top:'-2rem',
        right:'0px'
      }}>
        <img src="./icons/costelgpt-info.svg"></img>
      </button>
    </form>
  </div>
  );
}